import PortfolioView from 'backbone/portfolio/views/portfolio_view.js'

import RegistrationView from 'backbone/projects/views/registration_view.js'
import RegistrationSkillsView from 'backbone/projects/views/registration_skills_view.js'
import RegistrationTopicsView from 'backbone/projects/views/registration_topics_view.js'

export default {
  PortfolioView,

  RegistrationView,
  RegistrationSkillsView,
  RegistrationTopicsView
};



// WEBPACK FOOTER //
// ./app/javascript/backbone/outside/outside.js